<section id="dialogSection">
  <div class="control-card-white">

    <div class="control-card-header">
      <ng-container i18n="@@add_programmed_execution_dialog_title_add">Aggiungi automatismo</ng-container>
      <fa-icon icon="times" class="float-right margin-right-20 icon-clickable" (click)="closeDialog()"></fa-icon>
    </div>

    <div id="content" class="control-card-content">

      <div fxLayout="row" fxLayoutAlign="start start">

        <div fxFlex="60" class="table-container">

          <table mat-table matSort #deviceslisttable class="simple-table">

            <ng-container matColumnDef="serial">
              <th mat-header-cell mat-sort-header *matHeaderCellDef
                i18n="@@add_programmed_execution_dialog_tableHeader_serial" style="width: 5%;">Seriale</th>
              <td mat-cell *matCellDef="let device"> {{ device.serial }} </td>
            </ng-container>

            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header
                i18n="@@add_programmed_execution_dialog_tableHeader_description" style="width: 25%;">Descrizione</th>
              <td mat-cell *matCellDef="let device"> {{ device.name }} </td>
            </ng-container>

            <ng-container matColumnDef="checkbox">
              <th mat-header-cell *matHeaderCellDef> </th>
              <td mat-cell *matCellDef="let device" style="width: 5%;">
                <mat-checkbox (change)=addSelectedDevice(device) [checked]=device.selected>
                </mat-checkbox>
                <!-- [disabled]="(deviceSelected && !device.selected) || editing" -->
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

          </table>
        </div>

        <div fxFlex="10">
          <!-- Spazio vuoto -->
        </div>

        <div fxFlex="30" id="datesDiv" class="date-wrapper">

          <div id="fromDateDiv" class="date-container">
            <p class="text-small text-dark" i18n="@@add_programmed_execution_start_date">
              Data di inizio:
            </p>
            <input id="from-datepicker-input" [min]="minDate" [readonly]=true [ngxMatDatetimePicker]="fromDatepicker"
              [(ngModel)]="programmedExecution.fromDate" [formControl]="fromFormControl">
            <mat-datepicker-toggle matSuffix [for]="fromDatepicker"></mat-datepicker-toggle>
            <ngx-mat-datetime-picker #fromDatepicker [stepMinute]="5">
            </ngx-mat-datetime-picker>
          </div>
          <!-- (dateChange)="checkSelectedDates()" -->


          <div id="toDateDiv" class="date-container">
            <p class="text-small text-dark" i18n="@@add_programmed_execution__end_date">
              Data di fine:
            </p>
            <input id="from-datepicker-input" [min]="minDate" [readonly]=true [ngxMatDatetimePicker]="toDatePicker"
              [(ngModel)]="programmedExecution.toDate " [formControl]="toFormControl">
            <mat-datepicker-toggle matSuffix [for]="toDatePicker"></mat-datepicker-toggle>
            <ngx-mat-datetime-picker #toDatePicker [stepMinute]="5">
            </ngx-mat-datetime-picker>

          </div>

        </div>

      </div>

      <br>

      <div fxLayout="row" fxLayoutAlign="start center">
        <div fxFlex="20">
          <p i18n="@@add_programmed_execution_dialog_description">Descrizione: </p>
        </div>
        <div fxFlex>
          <input id="description-input" [(ngModel)]="description" />

        </div>
      </div>

    </div>

  </div>

  <div class="control-card-buttons">
    <br>
    <div>
      <a id="saveButton" (click)="createExecution()" class="button">
        <ng-container i18n="@@add_programmed_execution_dialog_save">Conferma</ng-container> <span>
          <fa-icon icon="save"></fa-icon>
        </span>
      </a>

      <a id="closeButton" (click)="closeDialog()" class="button button-red">
        <ng-container i18n="@@add_programmed_execution_dialog_discard">Scarta modifiche</ng-container> <span>
          <fa-icon icon="trash"></fa-icon>
        </span>
      </a>



    </div>

    <div id="errorsSpacerDiv" *ngIf="!invalidDatesError && !noDeviceSelectedError" fxLayout="row"
      fxLayoutAlign="center start">
    </div>

    <div id="errorsDiv" *ngIf="invalidDatesError || noDeviceSelectedError" fxLayout="row" fxLayoutAlign="center center">
      <div fxFlex="100">
        <p class="text-small text-error" *ngIf="invalidDatesError"
          i18n="@@add_programmed_execution_invalid_dates_error">
          Le date inserite non sono valide</p>

        <p class="text-small text-error" *ngIf="noDeviceSelectedError"
          i18n="@@add_programmed_execution_no_device_selected_error">Nessun
          dispositivo selezionato</p>
      </div>
    </div>

  </div>
</section>

  <app-loading-screen #loader [loading]="false"></app-loading-screen>
